import {
  Room,
  shuffleColor,
  getRandomEmoji,
  getRandomLatitude,
  getRandomLongitude,
  getRandomTimeLeft,
  getRandomGreeting,
} from '../../';

import { Coordinate } from '@breakroom-nx/helpers';
import { LngLatBounds } from 'react-map-gl';
const geofire = require('geofire-common');

// Generate Random Markers
export const generateMarkers = (count: number) => {
  const markers: Room[] = [];

  for (let i = 0; i < count; i++) {
    const greeting = getRandomGreeting();
    const color = shuffleColor();
    const emoji = getRandomEmoji();
    const lat = getRandomLatitude();
    const lon = getRandomLongitude();
    const geohash = geofire.geohashForLocation([lat, lon]);
    const vibe = 'welcome';
    const vibeIcon = '🆕';
    const location: Coordinate = { latitude: lat, longitude: lon };

    const created = new Date();
    const randomMinutes = Math.floor(Math.random() * 60);
    const randomExpirationTime = new Date(
      created.getTime() + 1 * randomMinutes * 60 * 1000
    );

    const dummyRoom = new Room({
      id: i.toString(),
      title: greeting,
      avatar: emoji,
      theme: color,
      location: location,
      geohash: geohash,
      created: created,
      expires: randomExpirationTime,
      newMessage: true,
      isDirect: false,
      vibe: vibe,
      vibeIcon: vibeIcon,
      lastMessage: {
        user: {
          _id: i.toString(),
          name: 'Greeter',
        },
        createdAt: new Date(),
        _id: i.toString(),
        text: greeting,
      },
    });

    markers.push(dummyRoom);
  }

  return markers;
};

/**
 * Haversine Formula for Converting Lat Lng to Meters
 * Takes the left and top-most map bounds takes the smaller one
 * This in essence takes the smaller dimension of the screen and creates a circular radius out of it from which to fetch chats.
 * @param mapBounds
 * @returns
 */
export function getNewBounds(mapBounds: LngLatBounds): string[][] {
  const { lat: centerLatitude, lng: centerLongitude } = mapBounds.getCenter();
  const leftBounds = mapBounds.getEast(); // Longitude
  const topBounds = mapBounds.getNorth(); // Latitude

  // Earth Radius in km
  const R = 6378.137;
  const latitudeDifference =
    (topBounds * Math.PI) / 180 - (centerLatitude * Math.PI) / 180; // Latitude
  const longitudeDifference =
    (leftBounds * Math.PI) / 180 - (centerLongitude * Math.PI) / 180; // Longitude

  const a =
    Math.sin(latitudeDifference / 2) * Math.sin(latitudeDifference / 2) +
    Math.cos((centerLatitude * Math.PI) / 180) *
      Math.cos((topBounds * Math.PI) / 180) *
      Math.sin(longitudeDifference / 2) *
      Math.sin(longitudeDifference / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInKM = R * c; // Distance in km
  const distance = distanceInKM * 1000; // meters

  // console.log(`Radius Distance in Meters: ${distance}`);

  const newBounds = geofire.geohashQueryBounds(
    [centerLatitude, centerLongitude],
    distance
  );
  return newBounds;
}
